export const MAX_CHARACTERS_TO_SHOW_TOOLTIP = 40;
